module.exports = __webpack_public_path__ + "img/primary-light.e2c14ae5.svg";